<template>
    <v-row>
        <v-col>
            <v-checkbox v-model="clearable" label="Clearable" @change="emit"/>
            <span class="body-2 text--secondary">If enabled, allows the user to clear the date, otherwise a date will always be present.</span>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'DateTime',
        data: () => ({
            clearable: true
        }),
        methods: {
            emit() {
                this.$emit('change', {
                    type: 'datetime',
                    clearable: this.clearable
                });
            }
        },
        created() {
            this.emit();
        }
    }
</script>

<style lang="scss" scoped>

</style>